import * as React from "react";
import BaseComponent from "src/engine/ui/BaseComponent";
import { FigureId, ClickType } from "./const";
import { Toast } from "antd-mobile";
// import { getUserInfo } from "../service";
// import { getCookie } from "../util";
import Utils from "src/lib/utils/Utils";
import "./index.scss";

import FigureModal from "./FigureModal";
import RuleModal from "./RuleModal";
import RoleModal from "./RoleModal";
import CheckModal from "./CheckModal";
import DrawModal from "./DrawModal";
import InvietDownLoadModal from "./InvietDownLoadModal";
import InvitePicTureModal from "./InvitePicTureModal";

interface IProps {}

interface IState {
    openAudio: boolean;
    /**皮肤视频id*/
    showVideoId: number;
    /**活动规则*/
    showRule: boolean;
    /**角色*/
    showRole: boolean;
    /**手机号验证*/
    showCheck: boolean;
    /**用户类型*/
    userType: string;
    /**是否获得下载奖励*/
    hasDownLoad: boolean;
    /**是否邀请他人下载*/
    hasInviteDownLoad: boolean;
    /**领取下载奖励*/
    showDraw: boolean;
    /**邀请下载*/
    showInviteDownLoad: boolean;
    /**邀请下载图片*/
    showInvitePicTure: boolean;
    /**点击的按钮*/
    clickBtn: string;
    /**角色id*/
    roleId: string;
    /**我的邀请码*/
    myCode: string;
}

const win: any = window;

const audioUrl = "https://webcloudplt.oss.jjbisai.com/fw/0/0840276407bbe4c0_2406848.mp3";

// 第一屏
class First extends BaseComponent<IProps, IState> {
    private audio: React.RefObject<any>;

    constructor(props: IProps) {
        super(props);
        this.state = {
            openAudio: false,
            showVideoId: 0,
            showRule: false,
            clickBtn: "",
            showRole: false,
            showCheck: false,
            userType: "",
            hasDownLoad: false,
            hasInviteDownLoad: false,
            showDraw: false,
            showInviteDownLoad: false,
            showInvitePicTure: false,
            roleId: "",
            myCode: "",
        };
        this.audio = React.createRef();
    }

    onAudioClick = () => {
        let openAudio = !this.state.openAudio;
        this.setState({
            openAudio,
        });
        if (openAudio) {
            this.audio.current.play();
        } else {
            this.audio.current.pause();
        }
    };

    /** 打开规则*/
    onOpenRule = () => {
        this.setState({
            showRule: true,
        });
    };

    /** 关闭规则*/
    onCloseRule = () => {
        this.setState({
            showRule: false,
        });
    };

    /** 修改我的邀请码*/
    changeMyCode = (myCode: string) => {
        this.setState({
            myCode,
        });
    };

    /** 修改roleId*/
    changeRoleId = (roleId: string) => {
        this.setState({
            roleId,
        });
    };

    /**
     * 更新奖励获取情况
     */
    updateUserDownLoadInfo = (hasDownLoad: boolean, hasInviteDownLoad: boolean) => {
        this.setState({
            hasDownLoad,
            hasInviteDownLoad,
        });
    };

    onSkinClick = (e: any, id: number = 0) => {
        e.stopPropagation();
        e.preventDefault();
        this.setState({
            showVideoId: id,
        });
        // 播放皮肤视频，关闭音乐
        this.setState({
            openAudio: false,
        });
        this.audio.current.pause();
    };

    onFingerClick = (id: number = 0) => {
        this.setState({
            showVideoId: id,
        });
        // 播放皮肤视频，关闭音乐
        this.setState({
            openAudio: false,
        });
        this.audio.current.pause();
    };

    /**打开分享图片*/
    onOpenInvitePicTure = () => {
        this.setState({
            showInviteDownLoad: false,
            showInvitePicTure: true,
        });
    };

    /**关闭分享图片*/
    onCloseInvitePicTure = () => {
        this.setState({
            showInviteDownLoad: true,
            showInvitePicTure: false,
        });
    };

    /**打开邀请下载*/
    onOpenInviteDownLoad = () => {
        this.setState({
            showInviteDownLoad: true,
        });
    };

    /**关闭邀请下载*/
    onCloseInviteDownLoad = () => {
        this.setState({
            showInviteDownLoad: false,
        });
    };

    /**打开领奖成功*/
    onOpenDraw = () => {
        this.setState({
            showDraw: true,
        });
    };

    /**关闭领奖成功*/
    onCloseDraw = () => {
        this.setState({
            showDraw: false,
        });
    };

    /**打开手机验证*/
    onOpenCheck = (userType: string) => {
        this.setState({
            userType: userType ? userType : "",
            showCheck: true,
        });
    };

    /**关闭手机验证*/
    onCloseCheck = () => {
        this.setState({
            showCheck: false,
        });
    };

    /**打开角色*/
    onOpenRole = () => {
        this.setState({
            showRole: true,
        });
    };

    /**关闭角色*/
    onCloseRole = () => {
        this.setState({
            showRole: false,
        });
    };

    /**
     * 点击萧汐儿，邀请下载
     */
    onInviteDownload = (e: any) => {
        const { hasDownLoad } = this.state;
        e.stopPropagation();
        e.preventDefault();
        this.setState({
            clickBtn: ClickType.XX,
        });
        //已领取下载奖励
        if (hasDownLoad) {
            this.onOpenInviteDownLoad();
            return;
        }
        this.onOpenRole();
    };

    /**
     * 点击宁琴，领取皮肤
     */
    onDrawSkin = (e: any) => {
        const { hasDownLoad } = this.state;
        e.stopPropagation();
        e.preventDefault();
        this.setState({
            clickBtn: ClickType.NQ,
        });
        if (hasDownLoad) {
            Toast.show("皮肤已获得", 3, true);
            return;
        }
        this.onOpenRole();
    };

    /**
     * 下载
     */
    onDownload = () => {
        const down_obj = win.jjmatch.login_down_jj.init({
            down_btn: document,
            andr_4g_place: "",
            andr_wifi_place: "",
            iph_url: "https://apps.apple.com/cn/app/%E6%88%91%E8%87%AA%E4%B8%BA%E9%81%93-%E7%BA%A2%E7%8E%84%E4%BC%A0/id1575181820",
            ipad_url: "https://apps.apple.com/cn/app/%E6%88%91%E8%87%AA%E4%B8%BA%E9%81%93-%E7%BA%A2%E7%8E%84%E4%BC%A0/id1575181820",
            weixin_tips_img: "//img1.cache.jj.cn/images/activitytopic/activity/2022/07/70caa83357.png",
            apkurl: "https://ly-pkg.cache.jj.cn/pkg/620091/release/android/jjgb/100089-productMode-gf_guanwang-202312181700.apk",
        });
        // const down_obj = win.jjmatch.login_down_jj.init({
        //     down_btn: document,
        //     andr_4g_place: "",
        //     andr_wifi_place: "",
        //     iph_url: "https://acts.jj.cn/html/activity_topic/sign_up/22071388808f.html",
        //     ipad_url: "https://acts.jj.cn/html/activity_topic/sign_up/22071388808f.html",
        //     weixin_tips_img: "//img1.cache.jj.cn/images/activitytopic/activity/2022/07/70caa83357.png",
        //     apkurl: "https://ly-pkg.cache.jj.cn/pkg/release/android/sms/NeiWang_Debug_0_红玄传_Android_1.0.0_1.0.0_2022_7_2_21_54_32_full.apk",
        // });
        down_obj.now_down();
    };

    renderDownloadBtn = () => {
        return (
            <div className="btn-yy" onClick={this.onDownload}>
                <div className="cy-bottom"></div>
                <div className="bg-yanzi"></div>
                <div className="bg-yuan"></div>
                <div className="bg-text"></div>
            </div>
        );
    };

    render() {
        const {
            openAudio,
            showVideoId,
            showRule,
            showRole,
            showCheck,
            userType,
            showDraw,
            showInviteDownLoad,
            showInvitePicTure,
            hasInviteDownLoad,
            hasDownLoad,
            clickBtn,
            roleId,
            myCode,
        } = this.state;
        const isIos = Utils.getIos();
        return (
            <div className="first-page">
                <div className="left-logo"></div>
                <div className="right-tip"></div>
                <div className={openAudio ? "btn-audio open" : "btn-audio"} onClick={this.onAudioClick}>
                    <audio ref={this.audio} src={audioUrl} preload="true"></audio>
                </div>
                <div className="bg-figure">
                    <div className="bg-box"></div>
                    {/* <div className="bg-time"></div> */}
                    <div className={`figure-${FigureId.XX}`} onClick={() => this.onFingerClick(FigureId.XX)}>
                        <div className="btn-figure-skin" onClick={(e) => this.onSkinClick(e, FigureId.XX)}></div>
                        <div className={hasInviteDownLoad ? "btn-figure finish ani" : "btn-figure ani"} onClick={(e) => this.onInviteDownload(e)}></div>
                    </div>
                    <div className={`figure-${FigureId.ZZ}`} onClick={() => this.onFingerClick(FigureId.ZZ)}>
                        <div className="btn-figure-skin" onClick={(e) => this.onSkinClick(e, FigureId.ZZ)}></div>
                        {/* <div className="btn-figure" onClick={(e) => this.onFingerBtnClick(e, FigureId.ZZ)}></div> */}
                    </div>
                    <div className={`figure-${FigureId.NQ}`} onClick={() => this.onFingerClick(FigureId.NQ)}>
                        <div className="btn-figure-skin" onClick={(e) => this.onSkinClick(e, FigureId.NQ)}></div>
                        <div className={hasDownLoad ? "btn-figure finish" : "btn-figure ani"} onClick={(e) => this.onDrawSkin(e)}></div>
                    </div>
                </div>
                {this.renderDownloadBtn()}
                <div className="btn-rule" onClick={this.onOpenRule}>
                    活动细则
                </div>
                {showVideoId ? <FigureModal key={showVideoId} showVideoId={showVideoId} onClose={() => this.onFingerClick(0)} /> : null}
                {showRule ? <RuleModal onClose={this.onCloseRule} /> : null}
                {showCheck ? (
                    <CheckModal
                        roleId={roleId}
                        clickBtn={clickBtn}
                        userType={userType}
                        onClose={this.onCloseCheck}
                        updateUserDownLoadInfo={this.updateUserDownLoadInfo}
                        changeMyCode={this.changeMyCode}
                        onOpenDraw={this.onOpenDraw}
                        onOpenInviteDownLoad={this.onOpenInviteDownLoad}
                    />
                ) : null}
                {showRole ? <RoleModal clickBtn={clickBtn} onClose={this.onCloseRole} onOpenCheck={this.onOpenCheck} changeRoleId={this.changeRoleId} /> : null}
                {showDraw ? <DrawModal onClose={this.onCloseDraw} /> : null}
                {showInviteDownLoad ? (
                    <InvietDownLoadModal myCode={myCode} onClose={this.onCloseInviteDownLoad} onOpenSharePic={this.onOpenInvitePicTure} />
                ) : null}
                {showInvitePicTure ? <InvitePicTureModal myCode={myCode} onClose={this.onCloseInvitePicTure} /> : null}
            </div>
        );
    }
}

export default First;
